export interface Device_MPE_Interface {
  id:number,

  mpe_min: number,
  mpe_max: number,
  mpe_sys: number,
  mpe_rnd: number,
  mpe_goal: number,
}

export function Empty_Device_MPE_Interface():Device_MPE_Interface{
  return{
    id: 0,

    mpe_min:0,
    mpe_max:0,
    mpe_sys:0,
    mpe_rnd:0,
    mpe_goal:0,
  }
}
